// About.js
import React, { useEffect, useState } from 'react';
import { Alert, Col, Container, Row, Tab, Tabs } from 'react-bootstrap';
import ComunidadMembresíaTabla from '../../components/comunidad/comunidadMembresiaTabla';
import ComunidadMembresíaGrafica from '../../components/comunidad/comunidadMembresiaGrafica';
import { getComunidad, setOrgToken } from '../../controllers/org';
import { Link, useParams } from 'react-router-dom';
import { useAuth } from '../../components/auth/AuthProvider';
import Loading from '../../components/loading/Loading';
import ComunidadMiembros from '../../components/comunidad/comunidadMiembros';
import ComunidadEquiposLista from '../../components/comunidad/comunidadEquiposLista';
import ComunidadCrearEquipo from '../../components/comunidad/comunidadCrearEquipo';
import ErrorAlert from '../../components/errors/ErrorAlert';
import ComunidadOrdenarLibros from '../../components/comunidad/comunidadOrdenarLibros';
import { setOrdersToken } from '../../controllers/orders';
import ComunidadOrderHistory from '../../components/comunidad/comunidadOrderHistory';
import Members from './Members';
import TransaccionesComunidad from './TransaccionesComunidad';
import YearSelector from '../../components/common/YearSelector';
import useYearParam from '../../hooks/useYearParam';
import ComunidadStatements from '../../components/tesoreria/comunidadStatements';

function Comunidad() {
  const params = useParams();
  const [ciclo, onCicloChange] = useYearParam();
  const { token, hasPermission } = useAuth();
  const [data, setData] = useState();
  const [errorCode, setErrorCode] = useState(); 
  setOrgToken(token);
  setOrdersToken(token);
  useEffect(() => {
    loadComunidad();
  }, [ciclo, params.comunidadId]);

  useEffect(() => {
    if (data) {
      document.title = `FAMA - Comunidad - ${data.comunidad.label}`;
    }
  }, [data]);

  async function loadComunidad() {
    try {
      let r = await getComunidad(params.comunidadId, ciclo);
      setData(r);
    }
    catch (e) {
      console.log(e);
      if (!isNaN(e.status)) {
        setErrorCode(e.status);
      }
    }
  }

  if (errorCode) {
    return <Container className='pt-5 pb-5'>
      <ErrorAlert code={errorCode} />
    </Container>;
  }
  if (!data) {
    return <Container className='pt-5 pb-5'>
      <h1>Comunidad</h1>
      <Row>
        <Loading text="Cargando..." />
      </Row>
    </Container>
  }

  let regionPath = `/app/org/regiones/${data.region.region_id}?ciclo=${ciclo}`;
  let regionLink = data.region.allowed ?
    <Link to={regionPath}>{data.region.label}</Link> :
    data.region.label;
  
  let diocesisPath = `/app/org/diocesis/${data.diocesis.diocesis_id}?ciclo=${ciclo}`;
  let diocesisLink = data.diocesis.allowed ?
    <Link to={diocesisPath}>{data.diocesis.label}</Link> :
    data.diocesis.label;

  let nacionalPath = `/app/org/nacional?ciclo=${ciclo}`;
  let nacionalLink = data.verMembresiaNacional ?
    <Link to={nacionalPath}>Nacional</Link> :
    'Nacional';

  let contenidoResumen;

  if (!data.members.members.count) {
    contenidoResumen = <Row>
      <Col>
        <Alert variant="warning">
          <p>No hay miembros en esta comunidad.</p>
        </Alert>
      </Col>
    </Row>;
  }
  else {
    contenidoResumen = <Row>
            <Col md={3}>
              <ComunidadMembresíaGrafica membresia={data.members.groups.countByProfileType} title="Membresía Por Tipo" />
            </Col>
            <Col md={3}>
              <ComunidadMembresíaGrafica membresia={data.members.groups.countByEtapa.filter(it => it.profileType === 1)} title="Matrimonios Por Nivel" />
            </Col>
            <Col md={3}>
              <ComunidadMembresíaGrafica membresia={data.members.groups.countByEtapa.filter(it => it.profileType === 2)} title="Mamás Por Nivel" />
            </Col>
            <Col md={3}>
              <ComunidadMembresíaTabla membresia={data.members.groups.countByProfileType} total={{count: data.members.groups.totalCount, paid: data.members.groups.totalPaid}} title="Resumen de Membresía"/>
            </Col>
          </Row>;
  }

  return (
    <Container className='pt-5 pb-5'>
      <Row className="mb-3">
        <Col><h1>{data.comunidad.label}</h1></Col>
        <Col md={3} className="ms-auto">
          <YearSelector
            value={ciclo}
            onChange={onCicloChange}
            keyPrefix="comunidad-year"
          />
        </Col>
      </Row>
      <Row className='pt-2 pb-2'>
        <Col>
          <p>{nacionalLink} / {regionLink} / {diocesisLink}</p>
        </Col>
      </Row>
      <Tabs>
        <Tab eventKey="resumen" title="Resumen">
          {contenidoResumen}
        </Tab>
        <Tab eventKey="miembros" title="Miembros" mountOnEnter={true} unmountOnExit={true}>
          <Members showYearSelector={false} />
        </Tab>
        <Tab eventKey="equipos" title="Equipos" mountOnEnter={true} unmountOnExit={true}>
          <Row>
            <Col md={8}><ComunidadEquiposLista equipos={data.equipos} miembros={data.members.members.rows}/></Col>
            <Col md={4}><ComunidadCrearEquipo comunidadId={params.comunidadId} miembros={data.members.members.rows} ciclo={ciclo} equipos={data.equipos} onSuccess={loadComunidad} /></Col>
          </Row>
        </Tab>
        { hasPermission('tesoreria_comunidad') && <Tab eventKey="tesoreria" title="Tesorería" mountOnEnter={true} unmountOnExit={true}>
          <Tabs>
            <Tab eventKey="libros" title="Ordenar libros" mountOnEnter={true} unmountOnExit={true}>
              <Row>
                <Col lg={8}><ComunidadOrdenarLibros 
                  type="comunidad"
                  comunidadId={params.comunidadId}
                  matrimonioPresidente={data.members.members.rows.filter(u => u.membership_roles.find(mr => mr.role_id === 23))[0]}
                  matrimonioTesorero={data.members.members.rows.filter(u => u.membership_roles.find(mr => mr.role_id === 26))[0]}
                /></Col>
              </Row>
            </Tab>
            <Tab eventKey="order-history" title="Historial de órdenes" mountOnEnter={true} unmountOnExit={true}>
              <ComunidadOrderHistory type="comunidad" />
            </Tab>
            <Tab eventKey="transacciones" title="Transacciones" mountOnEnter={true} unmountOnExit={true}>
              <TransaccionesComunidad />
            </Tab>
            <Tab eventKey="statements" title="Estados de Cuenta" mountOnEnter={true} unmountOnExit={true}>
              <ComunidadStatements comunidadId={params.comunidadId} ciclo={ciclo} />
            </Tab>
          </Tabs>
        </Tab> }
      </Tabs>
    </Container>
  );
}

export default Comunidad;
